var render = function render(){var _vm=this,_c=_vm._self._c;return _c('feature-card-data-row-input',_vm._b({attrs:{"value":_vm.value,"dense":"","items":_vm.usersArray,"menu-props":{ offsetY: true },"rules":_vm.rules,"data-type":_vm.dataType},on:{"input":function($event){return _vm.$emit('input', $event)}}},'feature-card-data-row-input',{ ..._vm.$props, ..._vm.$attrs },false))
}
var staticRenderFns = []

export { render, staticRenderFns }